module.exports = __webpack_public_path__ + "static/media/arrow-right-yellow.058b198e.svg";